import { useContext, useState } from 'react';

import ErrorMessage from 'components/common/ErrorMessage';
import StarRating from 'components/common/StarRating';
import { CustomerReportContext } from 'components/grace/Contexts';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import RequestService from 'services/RequestService';

const SurveyModalContent = ({ onRatingClick }) => {
  const { closedReportId } = useContext(CustomerReportContext);
  const [error, setError] = useState(null);
  const [rating, setRating] = useState(null);

  const handleRatingChange = useAnalyticsCallback(
    newRating => {
      if (newRating === undefined || newRating === null) return;

      const ratingValue = parseInt(newRating, 10);
      if (isNaN(ratingValue)) return;

      setRating(ratingValue);
      saveRating(ratingValue);
    },
    ({ logEvent, events, callbackArgs }) => {
      const [rating] = callbackArgs;
      logEvent(events.grace.reviewClicked, {
        csat_option: rating,
      });
    },
    [setRating, saveRating]
  );

  const saveRating = async ratingToSave => {
    if (ratingToSave === null) {
      return;
    }

    try {
      await RequestService.createSurveyRating({
        customerReportId: closedReportId,
        rating: ratingToSave,
      });

      onRatingClick();
    } catch {
      setError('Unable to save your rating. Please try again.');
    }
  };

  const titleText = () => {
    return rating === null ? 'How was your help experience?' : 'Thanks for your feedback.';
  };

  return (
    <>
      <div className="bp1:w-full">
        <section className="mb-6 px-6">
          <h2 className="h2 whitespace-pre-wrap text-charcoal-100">{titleText()}</h2>
          <p className="text pt-2 text-charcoal-90">We'll use this to improve our support.</p>
          {error && <ErrorMessage message={error} />}
        </section>
      </div>
      <div className="flex-left flex px-6 pb-6">
        <StarRating
          uniqueId={'survey-review'}
          onChange={rating => handleRatingChange(rating)}
          rating={rating}
          disabled={false}
          starSvgClassName="h-[29px] w-[29px]"
          starClassNames="mr-4"
        />
      </div>
    </>
  );
};

SurveyModalContent.propTypes = {
  onRatingClick: PropTypes.func.isRequired,
};

export default SurveyModalContent;
